import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { SyncLink, SyncObjectType } from "../models/sync-link.model";
import { EntityApiService } from "../../../shared/store/entity-store/entity-api.service";
import { QueryParam } from "../../../shared/store/store-types.model";
import { environment } from "../../../../environments/environment";
import { queryParamToHttp } from "../../../shared/store/utils/store-utils.service";

@Injectable({
  providedIn: "root",
})
export class SyncLinkApiService implements EntityApiService<SyncLink> {
  http = inject(HttpClient);

  constructor() {}

  loadByElement(
    elementType: SyncObjectType,
    elementId: string,
  ): Observable<SyncLink[]> {
    const params = queryParamToHttp({ elementType, elementId });
    return this.http.get<SyncLink[]>(`${environment.api()}/sync-link/`, {
      params,
    });
  }

  loadOne(id: string, query?: QueryParam): Observable<SyncLink> {
    throw new Error("Method not implemented.");
  }

  loadAll(query?: QueryParam): Observable<SyncLink[]> {
    throw new Error("Method not implemented.");
  }

  create(entity: SyncLink): Observable<SyncLink> {
    throw new Error("Method not implemented.");
  }

  remove(id: string): Observable<string> {
    throw new Error("Method not implemented.");
  }

  update(entity: SyncLink): Observable<SyncLink> {
    throw new Error("Method not implemented.");
  }

  linkArticle(articleId: string, connectorId: string): Observable<SyncLink> {
    return this.http.post<SyncLink>(`${environment.api()}/sync-link/link-article`, {
      articleId,
      connectorId,
    });
  }

  unlinkArticle(articleId: string, connectorId: string): Observable<void> {
    return this.http.post<void>(`${environment.api()}/sync-link/unlink-article`, {
      articleId,
      connectorId,
    });
  }

  /**
   * G5 — C15 warn-before-delete check.
   * Returns whether an internal entity is currently linked to any connector.
   */
  hasLink(
    elementType: SyncObjectType,
    elementId: string,
  ): Observable<{ hasLink: boolean; linkedConnectorIds: string[] }> {
    const params = queryParamToHttp({ elementType, elementId });
    return this.http.get<{ hasLink: boolean; linkedConnectorIds: string[] }>(
      `${environment.api()}/sync-link/has-link`,
      { params },
    );
  }

  /** Generic link — any SyncObjectType with a push flow. */
  link(
    elementType: SyncObjectType,
    elementId: string,
    connectorId: string,
  ): Observable<SyncLink> {
    return this.http.post<SyncLink>(`${environment.api()}/sync-link/link`, {
      elementType,
      elementId,
      connectorId,
    });
  }

  unlink(
    elementType: SyncObjectType,
    elementId: string,
    connectorId: string,
  ): Observable<{ unlinked: boolean }> {
    return this.http.post<{ unlinked: boolean }>(
      `${environment.api()}/sync-link/unlink`,
      { elementType, elementId, connectorId },
    );
  }
}
